import {
  SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_LABEL_MAPPING,
  SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_PREFIX
} from 'constants/companyCategory'
import { CATEGORY_PERMISSION_LABEL_MAPPING, CIXI_MODULES } from 'constants/role'

const separatorRegexp = /_(.*)/s

const filterByPro = (permissions = []) => {
  return permissions.filter((permission) => {
    if (!permission?.code) {
      return false
    }
    const prefix = permission.code.split(separatorRegexp)[0]
    return prefix === SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_PREFIX
  })
}

const getCodeSuffix = (permission) => {
  if (typeof permission !== 'string') return permission
  const arr = permission.split(separatorRegexp)
  if (arr[0] === SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_CODE_PREFIX) {
    return arr[1].split(separatorRegexp)[1]
  }
  return arr[1]
}

const groupCategoryPermissions = (permissions, categoryMapping) => {
  const groups = {}

  for (let i = 0; i < permissions.length; i += 1) {
    const permission = permissions[i]
    const { parentCategory, code } = permission
    const subCategory = categoryMapping[getCodeSuffix(code)]

    if (!subCategory) {
      // eslint-disable-next-line no-continue
      continue
    }

    if (groups[parentCategory]) {
      if (groups[parentCategory][subCategory]) {
        groups[parentCategory][subCategory].push(permission)
      } else {
        groups[parentCategory][subCategory] = [permission]
      }
      // eslint-disable-next-line no-continue
      continue
    }

    groups[parentCategory] = { [subCategory]: [permission] }
  }

  return groups
}

export const mapRoleDetail = (role) => {
  const { rolePermissions = [], ...args } = role || {}
  const permissions = rolePermissions.map((p) => p.permissions)
  const results = { ...args, permissions }
  switch (role.groupCode) {
    case CIXI_MODULES.backOffice:
      results.groupPermissions = groupCategoryPermissions(
        permissions,
        CATEGORY_PERMISSION_LABEL_MAPPING
      )
      break
    case CIXI_MODULES.serviceCenterMember:
      results.permissions = filterByPro(permissions)
      results.groupPermissions = groupCategoryPermissions(
        results.permissions,
        SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_LABEL_MAPPING
      )
      break
    default:
      break
  }
  results.codePermissions = (results.permissions || []).map(
    (permission) => permission.code
  )
  return results
}

export const mapCompanyCategoryDetail = (companyCategory = {}) => {
  const { permissions: categoryPermissions = [], ...args } = companyCategory
  const _permissions = categoryPermissions.map((p) => p.permissions)
  const permissions = filterByPro(_permissions) || []
  const codePermissions = permissions.map((permission) => permission.code)
  return {
    ...args,
    permissions,
    codePermissions,
    translations: (companyCategory.translations || []).map((l) => ({
      ...l,
      translationValue: l.labelCompanyCategoryTranslation
    })),
    groupPermissions: groupCategoryPermissions(
      permissions,
      SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_LABEL_MAPPING
    )
  }
}

export const mapCompanyRoleDetail = (role = {}) => {
  const {
    companyRolePermissions = [],
    companyRoleTranslation = [],
    ...args
  } = role?.companyRole || {}
  const _permissions = companyRolePermissions.map((p) => p.permissions)
  const permissions = filterByPro(_permissions) || []
  return {
    ...args,
    permissions,
    codePermissions: permissions.map((permission) => permission?.code),
    translations: companyRoleTranslation.map(({ languages, ...val }) => ({
      language: languages,
      ...val
    })),
    groupPermissions: groupCategoryPermissions(
      permissions,
      SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_LABEL_MAPPING
    )
  }
}

export const mapPermissions = (permissions, payload) => {
  const { items = [] } = permissions
  const newItems = items.filter((p) => p.groupCode === payload?.groupCode)
  switch (payload?.groupCode) {
    case CIXI_MODULES.backOffice:
      return groupCategoryPermissions(
        newItems,
        CATEGORY_PERMISSION_LABEL_MAPPING
      )
    case CIXI_MODULES.serviceCenterMember:
      return groupCategoryPermissions(
        filterByPro(newItems),
        SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_LABEL_MAPPING
      )
    default:
      return newItems
  }
}

export const mapPermissionsByCompanyId = (companyPermissions = []) => {
  const _permissions = companyPermissions.map((p) => p.permissions)
  const permissions = filterByPro(_permissions)
  return groupCategoryPermissions(
    permissions,
    SERVICE_CENTER_PLATFORM_CATEGORY_PERMISSION_LABEL_MAPPING
  )
}
